import React from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import fn from '../../helpers/fn';

export default fn(__filename, styled.a`
  color: inherit;
  line-height: initial;
  display: inline-block;
  text-decoration: none;
  border-bottom: solid 1px #000;
  cursor: pointer;

  ${({ white }) => white && `
    border-bottom-color: white;
  `};
`.withComponent(({
  white, to, // strip
  children,
  ...props
}) => (to ? (
  <Link {...{ ...props, to }}>{children}</Link>
) : (
  <a {...props}>{children}</a>
))));



// WEBPACK FOOTER //
// ./src/components/links/HeavyLink.js